import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const textHeroRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse, 'top 92%'),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    titleAnimation?.revert()
  }
}
